import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Dropdown, DropdownMenu, DropdownToggle } from 'reactstrap'; // apps
// import slackIcon from './icons/slack.png';
// import bitbucketIcon from './icons/bitbucket.png';
// import dribbbleIcon from './icons/dribbble.png';
// import dropboxIcon from './icons/dropbox.png';
// import githubIcon from './icons/github.png';
// import gSuiteIcon from './icons/g-suite.png';

import invoiceIcon from './icons/invoice.png';
import medicalReportIcon from './icons/medical-record.png';
import assistantReportIcon from './icons/assistant-report.png';
import patientIcon from './icons/patient.png';
import giftCardIcon from "./icons/gift-card.png";
const Apps = [{
  name: 'Invoice',
  icon: invoiceIcon,
  redirectTo: '/'
}, {
  name: 'Medical Record',
  icon: medicalReportIcon,
  redirectTo: '/'
}, {
  name: 'Patient',
  icon: patientIcon,
  redirectTo: '/'
}, {
  name: 'Gift Card',
  icon: giftCardIcon,
  redirectTo: '/'
}, {
  name: 'Assistant Report',
  icon: assistantReportIcon,
  redirectTo: '/'
}];

class AppsDropdown extends Component {
  constructor(props) {
    super(props);
    this.toggleDropdown = this.toggleDropdown.bind(this);
    this.state = {
      dropdownOpen: false
    };
  }
  /*:: toggleDropdown: () => void */


  toggleDropdown() {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen
    });
  }

  render() {
    const apps = Apps || [];
    const chunk_size = 3;
    const appsChunks = Array(Math.ceil(apps.length / chunk_size)).fill().map((_, index) => index * chunk_size).map(begin => apps.slice(begin, begin + chunk_size));
    return /*#__PURE__*/React.createElement(Dropdown, {
      isOpen: this.state.dropdownOpen,
      toggle: this.toggleDropdown
    }, /*#__PURE__*/React.createElement(DropdownToggle, {
      "data-toggle": "dropdown",
      tag: "button",
      className: "btn btn-link nav-link dropdown-toggle arrow-none mr-0",
      onClick: this.toggleDropdown,
      "aria-expanded": this.state.dropdownOpen
    }, /*#__PURE__*/React.createElement("i", {
      className: "mdi mdi-apps noti-icon"
    })), /*#__PURE__*/React.createElement(DropdownMenu, {
      right: true,
      className: "dropdown-menu-animated dropdown-lg p-0"
    }, /*#__PURE__*/React.createElement("div", {
      className: "p-2"
    }, appsChunks.map((chunk, idx) => /*#__PURE__*/React.createElement("div", {
      className: "row no-gutters",
      key: idx
    }, chunk.map((item, i) => /*#__PURE__*/React.createElement("div", {
      className: "col",
      key: i
    }, /*#__PURE__*/React.createElement(Link, {
      className: "dropdown-icon-item",
      to: item.redirectTo
    }, /*#__PURE__*/React.createElement("img", {
      src: item.icon,
      alt: ""
    }), /*#__PURE__*/React.createElement("span", null, item.name)))))))));
  }

}

export default AppsDropdown;